import { clx } from "../../../helpers/components";

export function LoaderSpinner({
    className,
    ...props
}){
    return(
        <span className={clx("loader", className)} {...props}></span>
    )
}